import { render, staticRenderFns } from "./WebShopPurchaseOffer.vue?vue&type=template&id=23e38f7a"
import script from "./WebShopPurchaseOffer.vue?vue&type=script&lang=js"
export * from "./WebShopPurchaseOffer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports